/**
 * @name rem
 */

export const rem = (fontSize, lineHeight) => `
        font-size: ${fontSize / 16}rem;
        line-height: ${lineHeight / 16}rem;
    `;
